import {
  BellSimpleIcon,
  BellSimpleRingingIcon,
  CheckIcon,
} from '@phosphor-icons/react';
import type { EventReminderSelectProps } from '@/lib/types/events.types';
import { ReminderTimeOption } from '@/lib/types/notifications.types';
import { EventDetailsContent } from '@/content/EventDetailsContent';

export function EventReminderSelect({
  selectedReminders,
  onToggle,
  isUpdating,
}: EventReminderSelectProps) {
  return (
    <div data-testid="event-reminder-section" className="py-6 bg-slate-600">
      <div className="flex items-center gap-2 mb-3">
        {selectedReminders.length > 0 ? (
          <BellSimpleRingingIcon
            size={20}
            weight="fill"
            className="text-purple-300"
          />
        ) : (
          <BellSimpleIcon
            size={20}
            weight="regular"
            className="text-purple-300"
          />
        )}
        <h4 className="text-purple-300">{EventDetailsContent.remindMe}</h4>
      </div>
      <div
        className={`flex flex-col gap-2 ${isUpdating ? 'opacity-50 pointer-events-none' : ''}`}
      >
        {EventDetailsContent.remindMeOptions.map((option) => {
          const isSelected = selectedReminders.includes(
            option.value as ReminderTimeOption
          );
          return (
            <button
              key={option.value}
              type="button"
              data-testid={`reminder-option-${option.value}`}
              data-selected={isSelected}
              onClick={() => onToggle(option.value as ReminderTimeOption)}
              disabled={isUpdating}
              className={`flex items-center justify-between w-full px-4 py-3 rounded-lg border transition-colors ${
                isSelected
                  ? 'bg-purple-300/20 border-purple-300 text-slate-50'
                  : 'bg-slate-600 border-slate-500 text-slate-300 hover:border-slate-400'
              }`}
            >
              <span className="text-body">{option.label}</span>
              <div
                className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${
                  isSelected
                    ? 'bg-purple-300 border-purple-300'
                    : 'border-slate-400'
                }`}
              >
                {isSelected && (
                  <CheckIcon
                    size={14}
                    weight="bold"
                    className="text-slate-900"
                  />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

